export class VariableHelper {
  public static extractVariable(value: string): string {
    if (value == null) {
      return value;
    }

    return value.replace('{', '').replace('}', '');
  }
}
